import React from "react";

export const LogicInteractionButton = (props) => {
    const {label, icon, onClick, disabled} = props;
    return (
        <button
            className="list node-command"
            onClick={onClick}
            disabled={disabled}
        >
            {icon}
            <span className="button-label">{label}</span>
        </button>
    )
}